import { generateUuid } from '@helpers/data';

import { WithdrawalsLimitsRecord } from '@types';

import { WithdrawalsAddLimitReducer } from './types';

export const withdrawalsAddLimitReducer: WithdrawalsAddLimitReducer = (
  state
) => {
  const newLimit: WithdrawalsLimitsRecord = {
    [generateUuid()]: {
      aggregatorId: undefined,
      currency: undefined,
      minAmount: undefined,
      maxAmount: undefined,
      limitType: undefined,
    },
  };

  return {
    ...state,
    withdrawalsLimitsProcessedItems: {
      ...state.withdrawalsLimitsProcessedItems,
      ...newLimit,
    },
  };
};
